(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

var _header = require('./public/components/header.js');

var _product_slider_hero_function = require('./public/sections/product_slider_hero_function.js');

var _product_slider_hero_function2 = _interopRequireDefault(_product_slider_hero_function);

var _viewport_animations = require('./public/sections/viewport_animations.js');

var _viewport_animations2 = _interopRequireDefault(_viewport_animations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import share_button_init from './public/components/share_button.js';
// import copyURL from './public/components/copy_url.js';
// import add_slider_function_init from './public/sections/add_slider_function.js';
(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function init() {
				(0, _header.header_menu_init)($);
				(0, _product_slider_hero_function2.default)($);
				(0, _viewport_animations2.default)($);
			},
			finalize: function finalize() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				// video_embed_play_overlay( $ );
			}
		},
		// Home page
		'home': {
			init: function init() {},
			finalize: function finalize() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function init() {
				// JavaScript to be fired on the about us page
			}

			// The routing fires all common scripts, followed by the page specific scripts.
			// Add additional events for more control over timing e.g. a finalize event
		} };var UTIL = {
		fire: function fire(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function loadEvents() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}

		// Load Events
	};$(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_b144bec4.js","/")
},{"./public/components/header.js":2,"./public/sections/product_slider_hero_function.js":3,"./public/sections/viewport_animations.js":4,"buffer":6,"rH1JPG":8}],2:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var burgerOpen = false;

var header = document.getElementsByClassName("header"),
    navButton = document.getElementById("nav-menu-button"),
    navUl = document.getElementsByClassName("menu grid-equalHeight"),
    navWrap = document.getElementsByClassName("menu-primary-navigation-container");

var mobileMenuOpen = false;

var mobileCEPMenuOpen = false;

function toggleMobileMenu() {
	if (mobileMenuOpen) {
		header[0].classList.remove("mobile-active"), navUl[0].classList.add("hide-ul"), navWrap[0].classList.add("hide-nav-wrap");
		mobileMenuOpen = false;
	} else {
		header[0].classList.add("mobile-active"), navUl[0].classList.remove("hide-ul"), navWrap[0].classList.remove("hide-nav-wrap");
		mobileMenuOpen = true;
	}
	if (mobileCEPMenuOpen) {
		jQuery('#mobile-menu-icon').toggleClass("menu-icon__open menu-icon__close");
		jQuery('#spotlight-menu-wrapper-mb').fadeToggle();
		mobileCEPMenuOpen = false;
	}
}
//	add a class to the primary nav ul, in order to toggle hide the mobile nav via the burger


function header_menu_init($) {

	$('.menu-primary-navigation-container').addClass('hide-nav-wrap');
	//	add a class to the nav container, in order to hide the container on mobile until opened

	$('.menu-primary-navigation-container').attr('aria-expanded', 'false');
	//	add role landmark and aria to improve accessibility.

	$('.menu-primary-navigation-container .menu').addClass('grid-equalHeight hide-ul');
	//	add a class to the primary nav ul, in order to hide the nav in mobile view by default

	$('.burger').attr('aria-expanded', 'false');
	//	add aria to improve accessibility.

	if (navButton == null) {
		return;
	}

	navButton.onclick = toggleMobileMenu;
	//	remove the hide-ul class once the menu button is click in mobile view

	$('.burger').click(function () {
		if (burgerOpen) {
			$(this).removeClass('open');
			burgerOpen = false;
		} else {
			$(this).addClass('open');
			burgerOpen = true;
		}
	});

	$(document).on('click', '#mobile-menu-icon', function () {
		if (mobileMenuOpen) {
			$('#nav-menu-button').click();
		}
		if (mobileCEPMenuOpen) {
			mobileCEPMenuOpen = false;
		} else {
			mobileCEPMenuOpen = true;
		}
	});

	$('.menu-item-has-children').addClass('has-subnav');
	//	add new has-subnav class to li's with subnav ul's

	if ($(".nav__item__text").length === 0) {
		$('.menu-primary-navigation-container .menu-item a').wrapInner('<span class="nav__item__text"></span>');
	}
	//	add a span to wrap the text in the header nav items

	var add_toggle_links = function add_toggle_links() {
		if ($('.menu-link').is(":visible")) {
			if ($(".toggle-link").length > 0) {} else {
				$('.has-subnav > a').after('<span class="toggle-link"></span>');
				$('.toggle-link').click(function (e) {
					var $this = $(this);
					if ($this.hasClass('active')) {
						$this.removeClass('active').siblings('ul').removeClass('active').parent('li').removeClass('active');
					} else {
						$('.toggle-link, li.has-subnav, ul.sub-menu').removeClass('active');
						$this.addClass('active').siblings('ul').addClass('active').parent('li').addClass('active');
					}
				});
			}
		} else {
			$('.toggle-link').empty();
		}
	};
	//	add additional span element if nav-items have sub-nav items, if the burger is visible

	add_toggle_links();
	$(window).bind("resize", add_toggle_links);
	//	only run this code if the window has been resized
}

exports.header_menu_init = header_menu_init;
exports.toggleMobileMenu = toggleMobileMenu;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/components/header.js","/public/components")
},{"buffer":6,"rH1JPG":8}],3:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = add_slider_function_init;
function add_slider_function_init($) {
	$(document).ready(function () {
		$('.section--product-slider-hero__slides').each(function (idx, item) {
			// var carouselId = "carousel" + idx;
			// this.id = carouselId;
			$(this).slick({
				//slide: "#" + carouselId +" .section",
				dots: true,
				customPaging: function customPaging(slider, i) {
					var title = $(slider.$slides[i]).data('title');
					var thumbnail = $(slider.$slides[i]).data('thumbnail');
					return '<a><img src="' + thumbnail + '" /><span>' + title + '</span></a>';
				},
				adaptiveHeight: true,
				autoplay: false,
				autoplaySpeed: 5000,
				arrows: false,
				pauseOnHover: false,
				speed: 750,
				fade: true,
				cssEase: 'ease-in-out',
				slidesToShow: 1,
				slidesToScroll: 1
			});
		});
	});
}

//	Assign dynamic carousel ID to each slider to enable multiple slider per page
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/product_slider_hero_function.js","/public/sections")
},{"buffer":6,"rH1JPG":8}],4:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = viewport_animations_init;
function viewport_animations_init($) {

	$(document).ready(function () {

		var siteMain = document.getElementsByClassName("main");
		var sections = document.querySelectorAll('.animate');

		// Helper: Checks given element is completely visible in viewport
		function isElementInViewport(el) {
			if (null === el) {
				return false;
			}

			var rect = el.getBoundingClientRect();
			var top = rect.top;
			var bottom = rect.bottom;
			var animationTriggerHeight = window.innerHeight * 0.8;

			/**
    * Potentially confusing logic ahead...
    * 
    * Condition: `bottom >= 0`
    * Is the bottom of the element below the top of the window?
    *
    * Condition: `top <= animationTriggerHeight`
    * Is the top of the element above the animation trigger height?
    * i.e. is enough of the element visible in the screen viewport to
    * start the animation?
    */
			return bottom >= 0 && top <= animationTriggerHeight;
		}

		// Helper: Runs the animation the first time the element becomes visible
		function onVisibilityChange(el, callback) {
			var old_visible = false;

			return function () {
				var visible = isElementInViewport(el);
				if (visible && visible !== old_visible) {
					if (typeof callback === "function") {
						callback(el);
					}
				}

				old_visible = visible;
			};
		}

		// Helper: Adds a class to an element so the animation runs
		function makeVisible(el) {
			if (!el.classList.contains("is-visible")) {
				el.classList.add("is-visible");
			}
		}

		for (var i = 0, secLen = sections.length; i < secLen; i++) {

			var animation_handler = onVisibilityChange(sections[i], makeVisible);

			// Add event listeners to fire the animation handler function
			window.addEventListener("DOMContentLoaded", animation_handler, false);
			window.addEventListener("load", animation_handler, false);
			window.addEventListener("scroll", animation_handler, false);
			window.addEventListener("resize", animation_handler, false);
		}
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/viewport_animations.js","/public/sections")
},{"buffer":6,"rH1JPG":8}],5:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/base64-js/lib/b64.js","/../../node_modules/base64-js/lib")
},{"buffer":6,"rH1JPG":8}],6:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = Buffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192

/**
 * If `Buffer._useTypedArrays`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (compatible down to IE6)
 */
Buffer._useTypedArrays = (function () {
  // Detect if browser supports Typed Arrays. Supported browsers are IE 10+, Firefox 4+,
  // Chrome 7+, Safari 5.1+, Opera 11.6+, iOS 4.2+. If the browser does not support adding
  // properties to `Uint8Array` instances, then that's the same as no `Uint8Array` support
  // because we need to be able to add all the node Buffer API methods. This is an issue
  // in Firefox 4-29. Now fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=695438
  try {
    var buf = new ArrayBuffer(0)
    var arr = new Uint8Array(buf)
    arr.foo = function () { return 42 }
    return 42 === arr.foo() &&
        typeof arr.subarray === 'function' // Chrome 9-10 lack `subarray`
  } catch (e) {
    return false
  }
})()

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (subject, encoding, noZero) {
  if (!(this instanceof Buffer))
    return new Buffer(subject, encoding, noZero)

  var type = typeof subject

  // Workaround: node's base64 implementation allows for non-padded strings
  // while base64-js does not.
  if (encoding === 'base64' && type === 'string') {
    subject = stringtrim(subject)
    while (subject.length % 4 !== 0) {
      subject = subject + '='
    }
  }

  // Find the length
  var length
  if (type === 'number')
    length = coerce(subject)
  else if (type === 'string')
    length = Buffer.byteLength(subject, encoding)
  else if (type === 'object')
    length = coerce(subject.length) // assume that object is array-like
  else
    throw new Error('First argument needs to be a number, array or string.')

  var buf
  if (Buffer._useTypedArrays) {
    // Preferred: Return an augmented `Uint8Array` instance for best performance
    buf = Buffer._augment(new Uint8Array(length))
  } else {
    // Fallback: Return THIS instance of Buffer (created by `new`)
    buf = this
    buf.length = length
    buf._isBuffer = true
  }

  var i
  if (Buffer._useTypedArrays && typeof subject.byteLength === 'number') {
    // Speed optimization -- use set if we're copying from a typed array
    buf._set(subject)
  } else if (isArrayish(subject)) {
    // Treat array-ish objects as a byte array
    for (i = 0; i < length; i++) {
      if (Buffer.isBuffer(subject))
        buf[i] = subject.readUInt8(i)
      else
        buf[i] = subject[i]
    }
  } else if (type === 'string') {
    buf.write(subject, 0, encoding)
  } else if (type === 'number' && !Buffer._useTypedArrays && !noZero) {
    for (i = 0; i < length; i++) {
      buf[i] = 0
    }
  }

  return buf
}

// STATIC METHODS
// ==============

Buffer.isEncoding = function (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.isBuffer = function (b) {
  return !!(b !== null && b !== undefined && b._isBuffer)
}

Buffer.byteLength = function (str, encoding) {
  var ret
  str = str + ''
  switch (encoding || 'utf8') {
    case 'hex':
      ret = str.length / 2
      break
    case 'utf8':
    case 'utf-8':
      ret = utf8ToBytes(str).length
      break
    case 'ascii':
    case 'binary':
    case 'raw':
      ret = str.length
      break
    case 'base64':
      ret = base64ToBytes(str).length
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = str.length * 2
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.concat = function (list, totalLength) {
  assert(isArray(list), 'Usage: Buffer.concat(list, [totalLength])\n' +
      'list should be an Array.')

  if (list.length === 0) {
    return new Buffer(0)
  } else if (list.length === 1) {
    return list[0]
  }

  var i
  if (typeof totalLength !== 'number') {
    totalLength = 0
    for (i = 0; i < list.length; i++) {
      totalLength += list[i].length
    }
  }

  var buf = new Buffer(totalLength)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

// BUFFER INSTANCE METHODS
// =======================

function _hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  assert(strLen % 2 === 0, 'Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var byte = parseInt(string.substr(i * 2, 2), 16)
    assert(!isNaN(byte), 'Invalid hex string')
    buf[offset + i] = byte
  }
  Buffer._charsWritten = i * 2
  return i
}

function _utf8Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf8ToBytes(string), buf, offset, length)
  return charsWritten
}

function _asciiWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(asciiToBytes(string), buf, offset, length)
  return charsWritten
}

function _binaryWrite (buf, string, offset, length) {
  return _asciiWrite(buf, string, offset, length)
}

function _base64Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(base64ToBytes(string), buf, offset, length)
  return charsWritten
}

function _utf16leWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf16leToBytes(string), buf, offset, length)
  return charsWritten
}

Buffer.prototype.write = function (string, offset, length, encoding) {
  // Support both (string, offset, length, encoding)
  // and the legacy (string, encoding, offset, length)
  if (isFinite(offset)) {
    if (!isFinite(length)) {
      encoding = length
      length = undefined
    }
  } else {  // legacy
    var swap = encoding
    encoding = offset
    offset = length
    length = swap
  }

  offset = Number(offset) || 0
  var remaining = this.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }
  encoding = String(encoding || 'utf8').toLowerCase()

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexWrite(this, string, offset, length)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Write(this, string, offset, length)
      break
    case 'ascii':
      ret = _asciiWrite(this, string, offset, length)
      break
    case 'binary':
      ret = _binaryWrite(this, string, offset, length)
      break
    case 'base64':
      ret = _base64Write(this, string, offset, length)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leWrite(this, string, offset, length)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toString = function (encoding, start, end) {
  var self = this

  encoding = String(encoding || 'utf8').toLowerCase()
  start = Number(start) || 0
  end = (end !== undefined)
    ? Number(end)
    : end = self.length

  // Fastpath empty strings
  if (end === start)
    return ''

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexSlice(self, start, end)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Slice(self, start, end)
      break
    case 'ascii':
      ret = _asciiSlice(self, start, end)
      break
    case 'binary':
      ret = _binarySlice(self, start, end)
      break
    case 'base64':
      ret = _base64Slice(self, start, end)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leSlice(self, start, end)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toJSON = function () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function (target, target_start, start, end) {
  var source = this

  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (!target_start) target_start = 0

  // Copy 0 bytes; we're done
  if (end === start) return
  if (target.length === 0 || source.length === 0) return

  // Fatal error conditions
  assert(end >= start, 'sourceEnd < sourceStart')
  assert(target_start >= 0 && target_start < target.length,
      'targetStart out of bounds')
  assert(start >= 0 && start < source.length, 'sourceStart out of bounds')
  assert(end >= 0 && end <= source.length, 'sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length)
    end = this.length
  if (target.length - target_start < end - start)
    end = target.length - target_start + start

  var len = end - start

  if (len < 100 || !Buffer._useTypedArrays) {
    for (var i = 0; i < len; i++)
      target[i + target_start] = this[i + start]
  } else {
    target._set(this.subarray(start, start + len), target_start)
  }
}

function _base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function _utf8Slice (buf, start, end) {
  var res = ''
  var tmp = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    if (buf[i] <= 0x7F) {
      res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i])
      tmp = ''
    } else {
      tmp += '%' + buf[i].toString(16)
    }
  }

  return res + decodeUtf8Char(tmp)
}

function _asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++)
    ret += String.fromCharCode(buf[i])
  return ret
}

function _binarySlice (buf, start, end) {
  return _asciiSlice(buf, start, end)
}

function _hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function _utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i+1] * 256)
  }
  return res
}

Buffer.prototype.slice = function (start, end) {
  var len = this.length
  start = clamp(start, len, 0)
  end = clamp(end, len, len)

  if (Buffer._useTypedArrays) {
    return Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    var newBuf = new Buffer(sliceLen, undefined, true)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
    return newBuf
  }
}

// `get` will be removed in Node 0.13+
Buffer.prototype.get = function (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` will be removed in Node 0.13+
Buffer.prototype.set = function (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

Buffer.prototype.readUInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  return this[offset]
}

function _readUInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    val = buf[offset]
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
  } else {
    val = buf[offset] << 8
    if (offset + 1 < len)
      val |= buf[offset + 1]
  }
  return val
}

Buffer.prototype.readUInt16LE = function (offset, noAssert) {
  return _readUInt16(this, offset, true, noAssert)
}

Buffer.prototype.readUInt16BE = function (offset, noAssert) {
  return _readUInt16(this, offset, false, noAssert)
}

function _readUInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    if (offset + 2 < len)
      val = buf[offset + 2] << 16
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
    val |= buf[offset]
    if (offset + 3 < len)
      val = val + (buf[offset + 3] << 24 >>> 0)
  } else {
    if (offset + 1 < len)
      val = buf[offset + 1] << 16
    if (offset + 2 < len)
      val |= buf[offset + 2] << 8
    if (offset + 3 < len)
      val |= buf[offset + 3]
    val = val + (buf[offset] << 24 >>> 0)
  }
  return val
}

Buffer.prototype.readUInt32LE = function (offset, noAssert) {
  return _readUInt32(this, offset, true, noAssert)
}

Buffer.prototype.readUInt32BE = function (offset, noAssert) {
  return _readUInt32(this, offset, false, noAssert)
}

Buffer.prototype.readInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null,
        'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  var neg = this[offset] & 0x80
  if (neg)
    return (0xff - this[offset] + 1) * -1
  else
    return this[offset]
}

function _readInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt16(buf, offset, littleEndian, true)
  var neg = val & 0x8000
  if (neg)
    return (0xffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt16LE = function (offset, noAssert) {
  return _readInt16(this, offset, true, noAssert)
}

Buffer.prototype.readInt16BE = function (offset, noAssert) {
  return _readInt16(this, offset, false, noAssert)
}

function _readInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt32(buf, offset, littleEndian, true)
  var neg = val & 0x80000000
  if (neg)
    return (0xffffffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt32LE = function (offset, noAssert) {
  return _readInt32(this, offset, true, noAssert)
}

Buffer.prototype.readInt32BE = function (offset, noAssert) {
  return _readInt32(this, offset, false, noAssert)
}

function _readFloat (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 23, 4)
}

Buffer.prototype.readFloatLE = function (offset, noAssert) {
  return _readFloat(this, offset, true, noAssert)
}

Buffer.prototype.readFloatBE = function (offset, noAssert) {
  return _readFloat(this, offset, false, noAssert)
}

function _readDouble (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 7 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 52, 8)
}

Buffer.prototype.readDoubleLE = function (offset, noAssert) {
  return _readDouble(this, offset, true, noAssert)
}

Buffer.prototype.readDoubleBE = function (offset, noAssert) {
  return _readDouble(this, offset, false, noAssert)
}

Buffer.prototype.writeUInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'trying to write beyond buffer length')
    verifuint(value, 0xff)
  }

  if (offset >= this.length) return

  this[offset] = value
}

function _writeUInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 2); i < j; i++) {
    buf[offset + i] =
        (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
            (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt16BE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, false, noAssert)
}

function _writeUInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffffffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 4); i < j; i++) {
    buf[offset + i] =
        (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt32BE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, false, noAssert)
}

Buffer.prototype.writeInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7f, -0x80)
  }

  if (offset >= this.length)
    return

  if (value >= 0)
    this.writeUInt8(value, offset, noAssert)
  else
    this.writeUInt8(0xff + value + 1, offset, noAssert)
}

function _writeInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fff, -0x8000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt16(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt16(buf, 0xffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt16LE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt16BE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, false, noAssert)
}

function _writeInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fffffff, -0x80000000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt32(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt32(buf, 0xffffffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt32LE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt32BE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, false, noAssert)
}

function _writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifIEEE754(value, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 23, 4)
}

Buffer.prototype.writeFloatLE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, false, noAssert)
}

function _writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 7 < buf.length,
        'Trying to write beyond buffer length')
    verifIEEE754(value, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 52, 8)
}

Buffer.prototype.writeDoubleLE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, false, noAssert)
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (typeof value === 'string') {
    value = value.charCodeAt(0)
  }

  assert(typeof value === 'number' && !isNaN(value), 'value is not a number')
  assert(end >= start, 'end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  assert(start >= 0 && start < this.length, 'start out of bounds')
  assert(end >= 0 && end <= this.length, 'end out of bounds')

  for (var i = start; i < end; i++) {
    this[i] = value
  }
}

Buffer.prototype.inspect = function () {
  var out = []
  var len = this.length
  for (var i = 0; i < len; i++) {
    out[i] = toHex(this[i])
    if (i === exports.INSPECT_MAX_BYTES) {
      out[i + 1] = '...'
      break
    }
  }
  return '<Buffer ' + out.join(' ') + '>'
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer._useTypedArrays) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1)
        buf[i] = this[i]
      return buf.buffer
    }
  } else {
    throw new Error('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function (arr) {
  arr._isBuffer = true

  // save reference to original Uint8Array get/set methods before overwriting
  arr._get = arr.get
  arr._set = arr.set

  // deprecated, will be removed in node 0.13+
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

// slice(start, end)
function clamp (index, len, defaultValue) {
  if (typeof index !== 'number') return defaultValue
  index = ~~index;  // Coerce to integer.
  if (index >= len) return len
  if (index >= 0) return index
  index += len
  if (index >= 0) return index
  return 0
}

function coerce (length) {
  // Coerce length to a number (possibly NaN), round up
  // in case it's fractional (e.g. 123.456) then do a
  // double negate to coerce a NaN to 0. Easy, right?
  length = ~~Math.ceil(+length)
  return length < 0 ? 0 : length
}

function isArray (subject) {
  return (Array.isArray || function (subject) {
    return Object.prototype.toString.call(subject) === '[object Array]'
  })(subject)
}

function isArrayish (subject) {
  return isArray(subject) || Buffer.isBuffer(subject) ||
      subject && typeof subject === 'object' &&
      typeof subject.length === 'number'
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    var b = str.charCodeAt(i)
    if (b <= 0x7F)
      byteArray.push(str.charCodeAt(i))
    else {
      var start = i
      if (b >= 0xD800 && b <= 0xDFFF) i++
      var h = encodeURIComponent(str.slice(start, i+1)).substr(1).split('%')
      for (var j = 0; j < h.length; j++)
        byteArray.push(parseInt(h[j], 16))
    }
  }
  return byteArray
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(str)
}

function blitBuffer (src, dst, offset, length) {
  var pos
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length))
      break
    dst[i + offset] = src[i]
  }
  return i
}

function decodeUtf8Char (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    return String.fromCharCode(0xFFFD) // UTF 8 invalid char
  }
}

/*
 * We have to make sure that the value is a valid integer. This means that it
 * is non-negative. It has no fractional component and that it does not
 * exceed the maximum allowed value.
 */
function verifuint (value, max) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value >= 0, 'specified a negative value for writing an unsigned value')
  assert(value <= max, 'value is larger than maximum value for type')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifsint (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifIEEE754 (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
}

function assert (test, message) {
  if (!test) throw new Error(message || 'Failed assertion')
}

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/buffer/index.js","/../../node_modules/buffer")
},{"base64-js":5,"buffer":6,"ieee754":7,"rH1JPG":8}],7:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/ieee754/index.js","/../../node_modules/ieee754")
},{"buffer":6,"rH1JPG":8}],8:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/process/browser.js","/../../node_modules/process")
},{"buffer":6,"rH1JPG":8}]},{},[1])